// for anonimization

const rulesDict =
{
  "SharedFunctionalGroupsSequence": "",
  "PerFrameFunctionalGroupsSequence": "",
  "NumberOfFrames": "",
  "EchoPulseSequence": "",
  "EchoPlanarPulseSequence": "",
  "SpectrallySelectedSuppression": "",

  "ImageType": "",
  "SOPClassUID": "",
  "SOPInstanceUID": "",
  "StudyDate": "18000101",
  "StudyTime": "000000",
  "AccessionNumber": "0",
  "Modality": "",
  "ReferringPhysicianName": "NA",
  "StudyDescription": "NA",
  "SeriesDescription": "",
  "PatientName": "Ortho^Pred",
  "PatientID": "NA",
  "PatientBirthDate": "18000101",
  "PatientAge": "",
  "PatientSex": "NA",
  "PlanarConfiguration": "",
  "ScanningSequence": "",
  "SequenceVariant": "",
  "ScanOptions": "",
  "MRAcquisitionType": "",
  "SliceThickness": "",
  "RepetitionTime": "",
  "EchoTime": "",
  "ImagingFrequency": "",
  "MagneticFieldStrength": "",
  "EchoTrainLength": "",
  "PatientPosition": "",
  "StudyInstanceUID": "",
  "SeriesInstanceUID": "",
  "StudyID": "NA",
  "SeriesNumber": "",
  "AcquisitionNumber": "",
  "InstanceNumber": "",
  "ImagePositionPatient": "",
  "ImageOrientationPatient": "",
  "FrameOfReferenceUID": "",
  "InversionTime": "",
  "Laterality": "",
  "PositionReferenceIndicator": "",
  "SliceLocation": "",
  "SamplesPerPixel": "",
  "PhotometricInterpretation": "",
  "Rows": "",
  "Columns": "",
  "PixelSpacing": "",
  "BitsAllocated": "",
  "BitsStored": "",
  "HighBit": "",
  "PixelRepresentation": "",
  "SmallestImagePixelValue": "",
  "LargestImagePixelValue": "",
  "WindowCenter": "",
  "WindowWidth": "",
  "PixelData": "",
}

module.exports = { rulesDict };
